import { useEffect, useState } from "react";
import { ToggleButton, AutoComplete, DecimalInput } from "components";
import { LabelledInput, LabelledSelect } from "../../../../Fields";
import { useInput } from "hooks";
import { getProductBrandAutocompleteApi } from "api";
import AutocompleteFreeText from "components/AutocompleteFreeText";
import { FREE_ITEM_INCENTIVE_PREDICTIVE_TEXT } from "config";

export const IncentiveFreeItemTextBuilder = ({
  value = "",
  onChange = () => { },
}) => {
  const isUpTo = useInput(false);
  const start = useInput(2);
  const end = useInput("");
  const type = useInput();
  const freeText = useInput("")
  const val = useInput("");
  const isPurchase = useInput(true);
  const pVal = useInput("");
  const pType = useInput("");
  const suffix = useInput("");

  const typeData = [
    { label: "$", value: "$" },
    { label: "Unit", value: "Unit" },
  ];

  const [incentiveText, setIncentiveText] = useState(value)

  const formatFirstLine = (st, ed, tp) => {
    let result = "";

    if (tp === "$") {
      if (st && ed) {
        result += `${st}-$${ed}`;
      } else if (st) {
        result += st;
      } else if (ed) {
        result += ed;
      }
      result = "$" + result;
    } else {
      if (st && ed) {
        result += `${st}-${ed}`;
      } else if (st) {
        result += st;
      } else if (ed) {
        result += ed;
      }
      // result = result + " Unit";
    }
    return result ? ` ${result}` : "";
  };
  const formatPurchase = (isP, pV, pT) => {
    if (isP) {
      if (pT === "$") {
        return ` w/purchase/$${pV}`;
      } else {
        return ` w/purchase/${pV}`;
      }
    }
    return "";
  };
  const handleUpdateValue = (isUT, st, ed, tp, va, isP, pV, pT, suf, ft) => {
    setIncentiveText(
      `${isUT ? "Up To " : ""}Free${formatFirstLine(st, ed, tp)}${ft ? ` ${ft}` : ""}${va ? ` ${va}` : ""
      }${formatPurchase(isP, pV, pT)}${suf ? ` ${suf}` : ""}`
    );
  };

  useEffect(() => {
    let main = value.trim();
    if (main.startsWith("Up To")) {
      isUpTo.setValue(true);
      main = main.slice(5).trim();
    } else {
      isUpTo.setValue(false);
    }
    if (main.startsWith("Free")) {
      main = main.slice(4).trim();
      const splits = main.split(" ");
      if (splits.length > 0) {
        if (splits[0].startsWith("$")) {
          type.setValue("$");
          const v = splits[0].slice(1).trim();
          const dashIdx = v.indexOf("-");
          if (dashIdx > 0) {
            start.setValue(v.slice(0, dashIdx).trim());
            end.setValue(v.slice(dashIdx + 2).trim());
          } else {
            start.setValue(v);
          }
          main = splits.slice(1).join(" ");
        } else if (splits.length > 1 && splits[1] === "Unit") {
          type.setValue("Unit");
          const v = splits[0].trim();
          const dashIdx = v.indexOf("-");
          if (dashIdx > 0) {
            start.setValue(v.slice(0, dashIdx).trim());
            end.setValue(v.slice(dashIdx + 2).trim());
          } else {
            start.setValue(v);
          }
          main = splits.slice(2).join(" ");
        }
      }
      const pIdx = main.indexOf("w/purchase/");
      if (pIdx >= 0) {
        // val.setValue(main.slice(0, pIdx).trim());
        main = main.slice(pIdx + 11).trim();
        const sufIdx = main.indexOf(" ");

        if (sufIdx > 0) {
          const v = main.slice(0, sufIdx).trim();
          if (v.startsWith("$")) {
            pType.setValue("$");
            pVal.setValue(v.slice(1).trim());
          } else {
            pType.setValue("Unit");
            if (typeof v === Number) {
              pVal.setValue(v.trim());
            }
          }
          suffix.setValue(main.slice(sufIdx).trim());
        } else {
          const v = main.trim();
          if (v.startsWith("$")) {
            pType.setValue("$");
            pVal.setValue(v.slice(1).trim());
          } else {
            pType.setValue("Unit");
            if (typeof v === Number) {
              pVal.setValue(v.trim());
            }
          }
          suffix.setValue("");
        }
      } else {
        // val.setValue(main);
        isPurchase.setValue(false);
        // suffix.setValue("");
      }
    }

    return () => { };
  }, [value]);

  useEffect(() => {
    onChange(incentiveText);
  }, [incentiveText])

  return (
    <>
      <div className="p-2 d-flex justify-content-between align-items-center">
        <ToggleButton className="mt-3" label="Up To" value={isUpTo.value} style={{ width: '35%' }}
          onChange={(e) => {
            isUpTo.setValue(e);
            handleUpdateValue(e, start.value, end.value, type.value, val.value, isPurchase.value, pVal.value, pType.value, suffix.value, freeText.value);
          }}
        />

        <div className="mt-3 mx-2">Free</div>

        {type.value === "$" ? (
          <DecimalInput labeled label="Start" placeholder="Start" style={{ width: '94%' }}
            value={start.value}
            onChange={(e) => {
              start.setValue(e);
              handleUpdateValue(isUpTo.value, e, end.value, type.value, val.value, isPurchase.value, pVal.value, pType.value, suffix.value, freeText.value);
            }}
          />
        ) : (
          <LabelledInput label="Start" placeholder="Start" style={{ width: '94%' }}
            allowclear="true" inputType="float" value={start.value}
            onChange={(e) => {
              start.setValue(e);
              handleUpdateValue(isUpTo.value, e, end.value, type.value, val.value, isPurchase.value, pVal.value, pType.value, suffix.value, freeText.value);
            }}
          />
        )}
        {type.value === "$" ? (
          <DecimalInput labeled label="End" placeholder="End" style={{ width: '96%' }}
            value={end.value}
            onChange={(e) => {
              end.setValue(e);
              handleUpdateValue(isUpTo.value, start.value, e, type.value, val.value, isPurchase.value, pVal.value, pType.value, suffix.value, freeText.value);
            }}
          />
        ) : (
          <LabelledInput label="End" placeholder="End" style={{ width: '96%' }}
            allowclear="true" inputType="float" value={end.value}
            onChange={(e) => {
              end.setValue(e);
              handleUpdateValue(isUpTo.value, start.value, e, type.value, val.value, isPurchase.value, pVal.value, pType.value, suffix.value, freeText.value);
            }}
          />
        )}
        <LabelledSelect label="Type" style={{ width: '94%' }}
          options={typeData} value={type.value}
          onChange={(e) => {
            type.setValue(e);
            handleUpdateValue(isUpTo.value, start.value, end.value, e, val.value, isPurchase.value, pVal.value, pType.value, suffix.value, freeText.value);
          }} />
      </div>
      <div className="p-2 justify-content-between align-items-center">
        <AutocompleteFreeText label="Free Text" value={freeText.value}
          data={FREE_ITEM_INCENTIVE_PREDICTIVE_TEXT}
          onChange={(e) => {
            freeText.setValue(e);
            handleUpdateValue(isUpTo.value, start.value, end.value, type.value, val.value, isPurchase.value, pVal.value, pType.value, suffix.value, e)
          }}
        />
      </div>
      <div className="p-2 justify-content-between align-items-center">
        <AutoComplete label="Product/Service" idField="ext_id" inputId="ext_brand_i"
          value={val.value} func={getProductBrandAutocompleteApi} showAddProduct={false}
          onSelectValue={(e) => {
            val.setValue(e);
            handleUpdateValue(isUpTo.value, start.value, end.value, type.value, e, isPurchase.value, pVal.value, pType.value, suffix.value, freeText.value)
          }}

          onChange={(e) => {
            val.setValue(e);
            handleUpdateValue(isUpTo.value, start.value, end.value, type.value, e, isPurchase.value, pVal.value, pType.value, suffix.value, freeText.value)
          }}

        />
      </div>
      <div className="p-2 d-flex justify-content-between align-items-center">
        <ToggleButton className="mt-3" label="w/purchase" value={isPurchase.value}
          onChange={(e) => {
            isPurchase.setValue(e);
            handleUpdateValue(isUpTo.value, start.value, end.value, type.value, val.value, e, pVal.value, pType.value, suffix.value, freeText.value);
          }}
        />

        {pType.value === "$" ? (
          <DecimalInput labeled label="Value" placeholder="Value" style={{ width: '94%' }} className="ml-2"
            value={pVal.value} disabled={!isPurchase.value}
            onChange={(e) => {
              pVal.setValue(e);
              handleUpdateValue(isUpTo.value, start.value, end.value, type.value, val.value, isPurchase.value, e, pType.value, suffix.value, freeText.value);
            }}
          />
        ) : (
          <LabelledInput label="Value" placeholder="Value" style={{ width: '94%' }} className="ml-2"
            allowclear="true" inputType="float" value={pVal.value} disabled={!isPurchase.value}
            onChange={(e) => {
              pVal.setValue(e);
              handleUpdateValue(isUpTo.value, start.value, end.value, type.value, val.value, isPurchase.value, e, pType.value, suffix.value, freeText.value);
            }}
          />
        )}

        <LabelledSelect label="Type" style={{ width: '94%' }} className="ml-2"
          options={typeData} value={pType.value} disabled={!isPurchase.value}
          onChange={(e) => {
            pType.setValue(e);
            handleUpdateValue(isUpTo.value, start.value, end.value, type.value, val.value, isPurchase.value, pVal.value, e, suffix.value, freeText.value);
          }}
        />

        <LabelledInput label="Suffix" placeholder="Suffix" className="ml-2"
          allowclear="true" value={suffix.value}
          onChange={(e) => {
            suffix.setValue(e);
            handleUpdateValue(isUpTo.value, start.value, end.value, type.value, val.value, isPurchase.value, pVal.value, pType.value, e, freeText.value);
          }}
        />
      </div>
    </>
  );
};